const replyToMessage = (state, action) => ({
  ...state,
  replyingMessageId: action.payload.messageId,
});

export default replyToMessage;
